export const ADD = 'entities/volunteerTime/ADD';
export const ADD_MULTIPLE = 'entities/volunteerTime/ADD_MULTIPLE';
export const REMOVE = 'entities/volunteerTime/REMOVE';
